<template>
  <div class="line-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/examline/lineitem">考试大纲</shBreadItem>
      <shBreadItem v-if="lineData.length"
        ><div class="bread">{{ lineData[0]?.lineName }}</div></shBreadItem
      >
    </shBread>
  </div>
  <div class="line">
    <div class="detail" v-for="item in lineData" :key="item.lineID">
      <div class="title">
        <h2>
          {{ item.lineName }}
        </h2>
        <hr />
      </div>
      <div class="content">
        <div class="con-top">
          <p>作者/来源：{{ item.lineAuthor }}</p>
          <p>时间：{{ item.updateAt }}</p>
        </div>
        <div class="con-detail" v-html="item.lineBody"></div>
      </div>
    </div>
    <div class="line-rvideo">
      <VideoRecommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { findLineDetail } from "@/api/news";
import { useRoute, useRouter } from "vue-router";
import { findVideoRecommand, findVideoRandom } from "@/api/video";
import VideoRecommend from "@/components/video-recommend.vue";
import { ElMessage } from "element-plus";
export default {
  components: { VideoRecommend },
  setup() {
    const lineData = ref([]);
    const route = useRoute();
    const VideoReCommend = ref([]);
    findLineDetail(route.query.lineID)
      .then((data) => {
        //console.log(data);
        try {
          lineData.value = data;
        } catch (error) {
          ElMessage({
            message: error.message,
            type: "error",
            plain: true,
          });
        }
      })
      .catch((error) => {
        ElMessage({
          message: error.message,
          type: "error",
          plain: true,
        });
      });

    //监控clID并获取相应推荐
    watch(
      () => route.query.clID,
      () => {
        //获取视频推荐

        if (route.query.clID) {
          const clID = route.query.clID?.split(",");
          findVideoRecommand(clID)
            .then((data) => {
              try {
                VideoReCommend.value = data.map((item) => {
                  return {
                    chID: item.chID,
                    maID: item.maID,
                    coID: item.coID,
                    clID: item.clID,
                    leName: item.leName,
                    leImg: "/web/" + item.leImg,
                    coverImg: "/web/" + item.coverImg,
                    grade: item.grade.find((ele) => ele._id == item.gradeID),
                    id: item._id,
                  };
                });
              } catch (error) {
                ElMessage({
                  message: error.message,
                  type: "error",
                  plain: true,
                });
              }
            })
            .catch((error) => {
              ElMessage({
                message: error.message,
                type: "error",
                plain: true,
              });
            });
        } else {
          findVideoRandom(10)
            .then((data) => {
              try {
                VideoReCommend.value = data.map((item) => {
                  return {
                    chID: item.chID,
                    maID: item.maID,
                    coID: item.coID,
                    clID: item.clID,
                    leName: item.leName,
                    leImg: "/web/" + item.leImg,
                    coverImg: "/web/" + item.coverImg,
                    grade: item.grade.find((ele) => ele._id == item.gradeID),
                    id: item._id,
                  };
                });
              } catch (error) {
                ElMessage({
                  message: error.message,
                  type: "error",
                  plain: true,
                });
              }
            })
            .catch((error) => {
              ElMessage({
                message: error.message,
                type: "error",
                plain: true,
              });
            });
        }
      },
      { immediate: true }
    );
    return { lineData, VideoReCommend };
  },
};
</script>

<style lang="less" scoped>
.line-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.line {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .detail {
    width: 850px;
    background: #fff;
    .title {
      h2 {
        line-height: 30px;
        text-align: center;
        padding-left: 5px;
        padding-right: 5px;
      }
      hr {
        border: #f5f5f5 solid 1px;
      }
    }
    .content {
      .con-top {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        p {
          padding-left: 35px;
          color: #777;
        }
      }
      .con-detail {
        width: 850px;
        align-items: center;
        padding: 15px 15px 20px 15px;
      }
    }
  }
  .line-rvideo {
    width: 350px;
  }
}
</style>
